import React from 'react';
import PropTypes from 'prop-types';
import css from './Location.scss';
import Title from 'common/Title';
import AccessibleDropdown from "../../../common/AccessibleDropdown";
import MaterialIcon from 'SF/MaterialIcon';
import {SFEntityID} from "../../../utils/types";

export default class Location extends React.Component {

  get options() {
    return this.props.locations
        // Make locations readable to AccessibleDropdown
        ? this.props.locations.map((location, index) => ({key: index, value: location.id, text: location.name}))
        : []
  }

  get instructions() {
      return !this.props.canChangeLocation || this.props.locationId
          ? <div className={css['instructions']}>{this.props.instructions}</div>
          : <div className={`${css['instructions']} ${css['red']}`}>
              <MaterialIcon icon='error' className={css['error-icon']} /> This field is required
          </div>;
  }

  get content() {
    return this.props.canChangeLocation && this.options.length > 1
      ? <div className={css['review-location']}>
          <div data-role="reviewLocation">
            <AccessibleDropdown
              className={!this.props.instructions ? css['bold-red-border'] : null}
              onChange={(e, {value}) => this.props.onLocationSelected(value)}
              aria-label='location'
              options={this.options}
              defaultValue={this.props.locationId}
              selectOnBlur={false}
              selection
              placeholder='Choose a location'
            />
          </div>
          {this.instructions}
        </div>
      : <div className={css['text']}>
          <div data-role="reviewLocation">{this.props.locationName || '-'}</div>
          {this.instructions}
        </div>;
  }

  render() {
    return (
      <div className={css["main"]}>
        <Title text="Location" />{this.props.canChangeLocation && this.options.length > 1 ? <span className={css["red"]}>*</span> : ''}
        {this.content}
      </div>
    );
  }
}

Location.propTypes = {
  canChangeLocation: PropTypes.bool,
  instructions: PropTypes.string,
  locationName: PropTypes.string,
  locations: PropTypes.array,
  locationId: SFEntityID,
  onLocationSelected: PropTypes.func
};
